<template>
    <div class="addteamUser">
        <div class="add_container">
            <div class="fai_notext_field  flex align-cen">
                <div class="fai_notext_field_label">成员姓名</div>
                  <div style="margin-left:50px;">
                   <el-input placeholder="请输入姓名" v-model="userName" clearable disabled></el-input>
                  </div>
            </div>
         <div class="fai_notext_field  flex align-cen">
             <div class="fai_notext_field_label" style="line-height:40px">成员分类</div>
             <div class="addform ">
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="item.id" v-for="item in itemList">{{item.name}}</el-checkbox>
                </el-checkbox-group>
             </div>
         </div>
         <div class="btm_btn_box flex align-cen">
            <div class="fai_submit_btn" @click="setClass">确定</div>
            <div class="fai_cancel_btn" @click="reback">取消</div>
         </div>
        </div>
    </div>
</template>
<script>
import {getTeamDetail,geAccountGroup,saveAccountGroupRelation} from "@/api/enterprise/index"; // 成员详情、成员分类列表、设置账号的成员分类
export default {
    name:'addteamUser',
    data () {
        return {
            checkList:[],
            authAppVOList:[],
            loginName:'',
            userName:'',
            loading:false,
            nowDate:'',
            endDate:'',
            expandall:true,
            radio:0,
            bussID:'',
            currentId:'',
            itemList:[],
            checkTrue:[],
            currentUserInfo:'',
            businessInfo:'',
            defaultProps: {
          children: 'appAuthAccountVOList',
          label: 'name',
        },
        authList:[],
          propList:[],
          groupIds:[],
        }
    },
    created () {
         let decryptQuery=this.$base64.decode(this.$route.query.parms); // 解密
         this.propList = JSON.parse(decryptQuery)
         this.userName = this.propList.userName
         this.loginName = this.propList.loginName
        const businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.businessInfo = businessInfo
        this.bussID = businessInfo.id
        this.gethisInfo()
        this.getGroup()
    },
    methods: {
        // 获取详情
        gethisInfo(){
             getTeamDetail({businessId:this.bussID,id: this.propList.id},'enterprise')
            .then(res =>{
        this.userName = res.data.userName
         this.loginName = res.data.loginName
         this.radio = Number(res.data.isAdmin)
         this.authAppVOList = res.data.authAppVOList
            })
        },
            // 获取当前成员分类
        getGroup(){
            geAccountGroup({
                id:this.bussID,
                name:'',
               accountId:this.propList.id
            })
            .then(res =>{
               this.checkList = []
               this.groupIds = []
                this.itemList = [...res.data]
                this.checkList = this.itemList.filter(item => item.num == 1).map(item => item.id);
            })
        },
        // 确定
        setClass(){
           if(this.checkList && !this.checkList.length) return this.$util.Notifi('请至少选择一个分类', "error", "fa-exclamation-circle");     
           let params = {
            accountId:this.propList.id,
            businessId:this.bussID,
            groupIds:this.checkList
           }
           saveAccountGroupRelation(params)
           .then(res =>{
             if(res.code == 0){
                 this.$util.Notifi('修改成功','success','fa-check')
                 this.$router.push('/webenterpriseManage/teamAdmin')
             }else{
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
             }
           })
        },
        // 返回上一页
        reback(){
            this.$router.push('/webenterpriseManage/teamAdmin')
        },
    },
}
</script>
<style lang="scss" scoped>
.addteamUser{
    padding-top: 30px;
    font-weight: 400;
    .add_container{
     position: relative;
    margin: 0 auto;
    width: 1000px;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    padding: 40px 105px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .fai_notext_field {
    min-height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    .fai_notext_field_label{
    font-size: 12px;
    color: #90909e;
    text-align: right;
    }
    }
    .btm_btn_box{
        margin-top: 30px;    
        justify-content: center;
    .fai_submit_btn,.fai_cancel_btn,.fai_cancel_btn1{
        width: 270px;
            height: 40px;
    line-height: 40px;
    background: rgba(255,255,255,1);
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s linear;
    text-align: center;
    }
    .fai_submit_btn{
        border: 1px solid rgba(1,87,255,1);
        color: #0157ff;
    }
    .fai_cancel_btn{
    border: 1px solid rgba(1,87,255,1);
    color: #0157ff;
    border: 1px solid #dadada;
    color: #90909e;
    margin-left: 30px;
    }
       .fai_cancel_btn1{
        border: 1px solid red;
    color: red;
    margin-left: 30px;
       }
    }
    }
}
::v-deep {
  .addform{
    margin-left: 50px;
    flex-wrap: wrap;
    .el-checkbox{
        display: block !important;
        margin-bottom: 5px;
    }
    .addform-list{
        // width: 100%;
        .appname{
            line-height:35px;
        }
        .apptime{
            color: red;
        }
    }
      .el-tree-node__content{
          height: 40px !important;
      }
      .el-tree{
          display: flex;
          flex-wrap: wrap;
      }
  }
}
</style>